/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { switchOnMock } from '@/data/utils/switchOnMock';

export const SITE_STORE_ID = switchOnMock({ value: '11601', mockValue: '11601' });
